import * as React from 'react';
import * as Locale from '../model/locale';
import Formsy from 'formsy-react';
import {Input, Row} from 'formsy-react-components';
import {SubmitButton} from './forms';
import {updateUserPassword, UserData} from '../model/account';
import {connect} from "react-redux";
import {Subheading} from "./subheading";
import {Button} from 'react-bootstrap';
import {isEmpty} from 'underscore';

export interface PasswordFormFieldsProps {
    onSubmit: Function;
    textForKey: Function;
    userData: UserData;
}
export class PasswordChangeForm extends React.Component<PasswordFormFieldsProps, any> {
    state: {
        canSubmit: boolean;
    };
    constructor() {
        super();
        this.state = {
            canSubmit: false
        };
    }
    enableButton() {
        this.setState({
            canSubmit: true
        });
    }
    disableButton() {
        this.setState({
            canSubmit: false
        });
    }
    render() {
        let {textForKey, onSubmit} = this.props;
        return (
            <Formsy.Form className="form-horizontal"
                         onValid={this.enableButton.bind(this)}
                         onInvalid={this.disableButton.bind(this)}
                         onValidSubmit={onSubmit}>
                <Input label={textForKey(Locale.TEXT_CURRENT_PASSWORD)}
                       name="pass3"
                       type="password"
                       required />
                <Input label={textForKey(Locale.TEXT_NEW_PASSWORD)}
                       name="pass1"
                       type="password"
                       validations="minLength:8"
                       validationErrors={{minLength: textForKey(Locale.TEXT_NEW_PASSWORD_ERROR)}}
                       required />
                <Input label={textForKey(Locale.TEXT_CONFIRM_PASSWORD)}
                       name="pass2"
                       type="password"
                       validations="equalsField:pass1"
                       validationErrors={{equalsField: textForKey(Locale.TEXT_CONFIRM_PASSWORD_ERROR)}}
                       required />
                <Row layout="horizontal">
                    <Button href="#/account/settings/" type="button">{textForKey(Locale.TEXT_MODAL_BUTTON_CANCEL)}</Button>
                </Row>
                <Row layout="horizontal">
                    <SubmitButton disabled={!this.state.canSubmit}
                                  defaultValue={textForKey(Locale.TEXT_MODAL_BUTTON_SAVE)} />
                </Row>

            </Formsy.Form>
        );
    }
}

interface PasswordPageFieldPrompts {
    dispatch?: Function;
    textForKey: Function;
    userData: UserData;
    status;
}

@connect(
    state => ({
        ui: state.ui,
        textForKey: state.data.textForKey,
        userData: state.data.user,
    })
)
export class PasswordPage extends React.Component<PasswordPageFieldPrompts, any> {
    submitChanges(data) {
        let {dispatch, textForKey} = this.props;
        if (!(isEmpty(data))) {
            dispatch(updateUserPassword(data, textForKey));
        }
    }
    render () {
        let {textForKey, userData} = this.props;
        let userSubmit = this.submitChanges.bind(this);
        return (
            <div className="container content">
                <Subheading title={textForKey(Locale.TEXT_CHANGE_PASSWORD)}/>
                <div className="form col-md-10 col-md-offset-1 col-sm-12 col-sm-offset-0">
                    <PasswordChangeForm
                        textForKey={textForKey}
                        userData={userData}
                        onSubmit={userSubmit}/>

                </div>
            </div>
        );
    }
}
